import { useContext, useEffect, useState } from "react";
import "../../components/Question/question.scss";
import {
  MarkDocumentRead, 
} from "../../utils/Api/api";
import parser from "html-react-parser";
import { useNavigate } from "react-router-dom";
import { Context } from "../../contextApi/contextProvider";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { ShimmerLoaderwhite } from "../../utils/loader/ShimmerLoader";
import { PageRoutes } from "../../utils/pageRoutes";
import { cmsPrivateContent } from "../../utils/cmscontent/cms";
import { Stage } from "../../components/Question/Question";
import "./projections.scss";
import { ArrowLeft, ArrowRight } from "lucide-react";

const BusinessPlan = () => {
  const token = JSON.parse(localStorage.getItem("access_token") as string);

  const [currentStatus, setCurrentStatus] = useState({
    name: "",
    status: "",
    uid: "",
  });

  const navigator = useNavigate();
  const { userLoginData, accessDoc } =
    useContext(Context);
  const loaction = useGeoLocation();
  const [htmlString, setHtmlStr] = useState("");

  const getDocumentStatusByPostId = (
    stages: Stage[],
    stage_name: string
  ): string | undefined => {
    return stages
      .find((stage) => stage.stage_name.trim() === stage_name)
      ?.stage_status.trim();
  };

  const readDoc = async () => {
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "13656",
      });
    } catch (error) {}
  };
  const fetchCmsContent = async () => {
    const response = await cmsPrivateContent({
      post_id: "13656",
      lat: loaction.coordinates.lat,
      log: loaction.coordinates.lng,
    });
    setHtmlStr(response);
  };
  useEffect(() => {
    if (userLoginData.status == 200 && accessDoc["13656"] !== "de") {
      if (accessDoc["13656"] == "ALLOWED") {
        readDoc();
        if (accessDoc?.all_stage_info) {
          const financialProjectionStage = getDocumentStatusByPostId(
            accessDoc?.all_stage_info,
            "Stage 3 - Safe Details"
          );
          if (financialProjectionStage) {
            setCurrentStatus({
              name: "",

              uid: "",
              status: financialProjectionStage || "",
            });
            fetchCmsContent();
          } else {
            setCurrentStatus({
              name: "",

              uid: "",
              status: financialProjectionStage || "",
            });
            fetchCmsContent();
          }
        }
      } else {
        navigator("/");
      }
    } else if (userLoginData.status == 404) {
      navigator("/");
    } else if (token === "" || token === null || token === undefined) {
      navigator("/");
    }

    window.scrollTo(0, 0);
    document.title = "TICCA | Projections";
  }, [userLoginData.status, accessDoc]);

  return (
    <>
      {currentStatus?.status == "PENDING" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">
                Your request has been sent and we will respond as soon as
                possible
              </p>
            </div>
          </div>
        </>
      ) : currentStatus?.status == "ALLOWED" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">
                Your request is already accepted
              </p>
            </div>
          </div>
        </>
      ) : currentStatus?.status == "DENIED" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">Your request is denied</p>
            </div>
          </div>
        </>
      ) : htmlString == "" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            {[0, 0, 0, 0].map((elem: number, index: number) => (
              <>
                <ShimmerLoaderwhite maxWidth="100vw" />
              </>
            ))}
          </div>
        </>
      ) : (
        <>
            {htmlString.length &&  <div className="watermaring-main-dev-1">
        <img
          src="https://public.ticca.com/images/svg/Watermark_Business_Summary_Gray.svg"
          alt="logo"
        />
        <p>
          Commercial in Confidence <br />
          Content under NDA.
          <br /> {userLoginData?.email}
        </p>
      </div> }
          <div className="projection-main-dev">
            <div className="projection-sub-dev">
              {htmlString[0] && parser(htmlString[0])}
            </div>
               <div className="w-full flex justify-center py-0">
                    <div className="flex flex-col sm:flex-row items-center gap-8">
                      {/* Back Button */}
                      <div className="relative group">
                        <button
                          onClick={() => {
                            navigator(PageRoutes.ExecutiveSummary);
                          }}
                          className="
                          flex items-center gap-2 px-8 py-3 rounded-2xl
                          bg-white text-gray-700 font-semibold shadow-md
                          border border-gray-200
                          hover:shadow-lg hover:bg-gray-50
                          disabled:opacity-60 disabled:cursor-not-allowed
                          transition-all duration-300
                        "
                        >
                          <>
                            <ArrowLeft size={18} />
                            Back
                          </>
                        </button>
            
                        {/* Tooltip */}
                        <div
                          className="
                          absolute left-1/2 -translate-x-1/2 -top-12
                          bg-black text-white text-xs px-3 py-1 rounded-md
                          opacity-0 group-hover:opacity-100
                          transition-all duration-300
                          shadow-md whitespace-nowrap
                        "
                        >
                          Bussiness Summary
                        </div>
                      </div>
            
                      {/* Next Button */}
                      <div className="relative group">
                        <button
                          onClick={() => {
                           navigator(PageRoutes.SafeFrom);
                          }}
                          className="
                          flex items-center gap-2 px-10 py-3 rounded-2xl
                          bg-gradient-to-r from-blue-600 to-cyan-400
                          text-white font-semibold shadow-md
                          hover:shadow-xl hover:scale-[1.02]
                          disabled:opacity-60 disabled:cursor-not-allowed
                          transition-all duration-300
                        "
                        >
                          <> Access SAFE Agreement to be a part of TICCA <ArrowRight size={18} /></>
                        </button>
            
                        {/* Tooltip */}
                        <div
                          className="
                          absolute left-1/2 -translate-x-1/2 -top-12
                          bg-black text-white text-xs px-3 py-1 rounded-md
                          opacity-0 group-hover:opacity-100
                          transition-all duration-300
                          shadow-md whitespace-nowrap
                        "
                        >
                           Access SAFE Agreement to be a part of TICCA
                        </div>
                      </div>
                    </div>
                  </div>
          </div>
        </>
      )}
    </>
  );
};

export default BusinessPlan;
